module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('xi-top'), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "fullscreen": true
      }
    }],
    staticClass: "baseInfo"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('comb.releaseTask')))])]), _vm._v(" "), _c('el-form', {
    ref: "task",
    staticClass: "form",
    attrs: {
      "model": _vm.task,
      "label-position": "top",
      "rules": _vm.rules
    }
  }, [_c('el-tabs', {
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "baseInfo",
      "disabled": true
    }
  }, [_c('div', {
    staticClass: "tab-slot-wrapper",
    slot: "label"
  }, [_c('div', {
    staticClass: "tabs-item first-item"
  }, [_vm._v(_vm._s(_vm.$t('comb.baseInfo')))]), _vm._v(" "), _c('div', {
    staticClass: "arrow-right"
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "size": "large",
      "label": _vm.multiTaskName,
      "prop": "taskName",
      "required": true
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.task.taskName),
      callback: function($$v) {
        _vm.task.taskName = $$v
      },
      expression: "task.taskName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    ref: "taskType",
    attrs: {
      "size": "large",
      "label": _vm.multiTaskCategory,
      "required": true
    }
  }, [_c('el-cascader', {
    attrs: {
      "props": _vm.categoryProps,
      "expand-trigger": "hover",
      "show-all-levels": false,
      "options": _vm.categoryList,
      "filterable": ""
    },
    on: {
      "change": _vm.changeCategoryType
    },
    model: {
      value: (_vm.task.category),
      callback: function($$v) {
        _vm.task.category = $$v
      },
      expression: "task.category"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.multiTaskCover,
      "required": true
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('sen.pictureUploadLimit')))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "coverImgUrl",
      "required": true
    }
  }, [_c('el-upload', {
    attrs: {
      "action": "/dtres/backend/album/upload",
      "type": "drag",
      "show-file-list": false,
      "v-model": _vm.task.coverImgUrl,
      "before-upload": _vm.uploadBefore,
      "multiple": false,
      "on-success": _vm.uploadSuccess,
      "file-list": _vm.fileList
    }
  }, [(_vm.task.coverImgUrl) ? _c('img', {
    staticClass: "wrapper-upload-small",
    attrs: {
      "src": _vm.uploadedPic
    }
  }) : _c('div', {
    staticClass: "wrapper-upload-small"
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.multiTaskIntro,
      "prop": "taskDescription"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 2000,
      "type": "textarea"
    },
    model: {
      value: (_vm.task.taskDescription),
      callback: function($$v) {
        _vm.task.taskDescription = $$v
      },
      expression: "task.taskDescription"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    staticClass: "submit-button",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.nextTab('cooperationInfo')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('word.nextStep')))])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "cooperationInfo",
      "disabled": true
    }
  }, [_c('div', {
    staticClass: "tab-slot-wrapper",
    slot: "label"
  }, [_c('div', {
    staticClass: "tabs-item second-item"
  }, [_vm._v(_vm._s(_vm.$t('comb.taskRequirement')))]), _vm._v(" "), _c('div', {
    staticClass: "arrow-right"
  })]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "598px"
    },
    attrs: {
      "required": true
    }
  }, [_c('el-row', [_c('el-col', [_c('span', {
    staticClass: "form-item-label"
  }, [_vm._v(_vm._s(_vm.multUpdateFrequency))]), _vm._v(" "), _c('el-tooltip', {
    staticClass: "tips",
    attrs: {
      "effect": "dark",
      "placement": "right"
    }
  }, [_c('div', {
    slot: "content"
  }, [_vm._v("提示：每集约为20分钟")]), _vm._v(" "), _c('span', [_vm._v("?")])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-select', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.task.frequency),
      callback: function($$v) {
        _vm.task.frequency = $$v
      },
      expression: "task.frequency"
    }
  }, _vm._l((_vm.$store.state.publishFrequency), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.muiltDisplayWay,
      "required": true
    }
  }, [_c('el-select', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.task.playMode),
      callback: function($$v) {
        _vm.task.playMode = $$v
      },
      expression: "task.playMode"
    }
  }, _vm._l((_vm.$store.state.playMode), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.muiltReleaseMode,
      "required": true
    }
  }, [_c('el-select', {
    attrs: {
      "type": "text"
    },
    on: {
      "change": _vm.changePublishMethod
    },
    model: {
      value: (_vm.task.publishMethod),
      callback: function($$v) {
        _vm.task.publishMethod = $$v
      },
      expression: "task.publishMethod"
    }
  }, _vm._l((_vm.$store.state.publishMethods), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "598px"
    },
    attrs: {
      "prop": "basePay",
      "required": true
    }
  }, [_c('el-row', [_c('el-col', [_c('span', {
    staticClass: "form-item-label"
  }, [_vm._v(_vm._s(_vm.muiltTaskPay))]), _vm._v(" "), _c('el-tooltip', {
    staticClass: "tips",
    attrs: {
      "effect": "dark",
      "placement": "right"
    }
  }, [_c('div', {
    slot: "content"
  }, [_vm._v("提示：任务酬劳不低于100元每小时。"), _c('br'), _vm._v("酬劳越高，将有更多主播参与海选，您选中合适主播的概率越高。")]), _vm._v(" "), _c('span', [_vm._v("?")])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-input-number', {
    staticClass: "center",
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "controls": false
    },
    model: {
      value: (_vm.task.basePay),
      callback: function($$v) {
        _vm.task.basePay = $$v
      },
      expression: "task.basePay"
    }
  }), _c('span', {
    staticStyle: {
      "line-height": "52px",
      "vertical-align": "text-bottom"
    }
  }, [_vm._v("元/小时")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('el-button', {
    staticClass: "submit-button",
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.nextTab('baseInfo')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('word.prevStep')))]), _vm._v(" "), _c('el-button', {
    staticClass: "submit-button",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.nextTab('additionInfo')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('word.nextStep')))])], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "additionInfo",
      "disabled": true
    }
  }, [_c('div', {
    staticClass: "tab-slot-wrapper",
    slot: "label"
  }, [_c('div', {
    staticClass: "tabs-item third-item"
  }, [_vm._v(_vm._s(_vm.$t('comb.additionRequirement')))]), _vm._v(" "), _c('div', {
    staticClass: "arrow-right"
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.muiltAdditionRequirement,
      "prop": "additionRequirement"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.task.additionRequirement),
      callback: function($$v) {
        _vm.task.additionRequirement = $$v
      },
      expression: "task.additionRequirement"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "size": "large",
      "prop": "additionLimit",
      "label": _vm.muiltAdditionCycle,
      "required": true
    }
  }, [_c('el-select', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.task.additionLimit),
      callback: function($$v) {
        _vm.task.additionLimit = $$v
      },
      expression: "task.additionLimit"
    }
  }, _vm._l((_vm.$store.state.additionLimits), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "试音内容",
      "prop": "sampleMaterialText",
      "required": true
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入1000~2000字的试音内容"
    },
    model: {
      value: (_vm.task.sampleMaterialText),
      callback: function($$v) {
        _vm.task.sampleMaterialText = $$v
      },
      expression: "task.sampleMaterialText"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('el-button', {
    staticClass: "submit-button",
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.nextTab('cooperationInfo')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('word.prevStep')))]), _vm._v(" "), _c('el-button', {
    staticClass: "submit-button",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.nextTab('preview')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('word.nextStep')))])], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "preview",
      "disabled": true
    }
  }, [_c('div', {
    staticClass: "tab-slot-wrapper",
    slot: "label"
  }, [_c('div', {
    staticClass: "tabs-item fourth-item"
  }, [_vm._v("确认任务")])]), _vm._v(" "), _c('div', {
    staticClass: "data-wrapper"
  }, [_c('div', {
    staticClass: "data-row"
  }, [_c('span', {
    staticClass: "data-label"
  }, [_vm._v("任务类型")]), _vm._v(" "), _c('span', {
    staticClass: "data-value"
  }, [_vm._v(_vm._s(_vm.task.categoryLabel))])]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('span', {
    staticClass: "data-label"
  }, [_vm._v("发布方式")]), _vm._v(" "), _c('span', {
    staticClass: "data-value colored"
  }, [_vm._v(_vm._s(_vm.task.publishMethodLabel))])]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('span', {
    staticClass: "data-label"
  }, [_vm._v("任务名称")]), _vm._v(" "), _c('span', {
    staticClass: "data-value colored"
  }, [_vm._v(_vm._s(_vm.task.taskName))])]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('span', {
    staticClass: "data-label"
  }, [_vm._v("关联版权")]), _vm._v(" "), _c('span', {
    staticClass: "data-value"
  }, [_vm._v(_vm._s(_vm.task.bookName))])]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('span', {
    staticClass: "data-label"
  }, [_vm._v("更新频率")]), _vm._v(" "), _c('span', {
    staticClass: "data-value"
  }, [_vm._v(_vm._s(_vm.task.frequency) + "，每集约20分钟")])]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('span', {
    staticClass: "data-label"
  }, [_vm._v("演绎方式")]), _vm._v(" "), _c('span', {
    staticClass: "data-value"
  }, [_vm._v(_vm._s(_vm.$store.state.playMode[_vm.task.playMode - 1].label))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('span', {
    staticClass: "data-label"
  }, [_vm._v("招募方式")]), _vm._v(" "), _c('span', {
    staticClass: "data-value"
  }, [_vm._v("海选选拔")])]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('span', {
    staticClass: "data-label"
  }, [_vm._v("招募人数")]), _vm._v(" "), _c('span', {
    staticClass: "data-value"
  }, [_vm._v("1人")])]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('span', {
    staticClass: "data-label"
  }, [_vm._v("海选期限")]), _vm._v(" "), _c('span', {
    staticClass: "data-value"
  }, [_vm._v(_vm._s(_vm.task.additionLimit) + "天")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('span', {
    staticClass: "data-label"
  }, [_vm._v("演播字数")]), _vm._v(" "), _c('span', {
    staticClass: "data-value colored"
  }, [_vm._v(_vm._s(_vm.task.words))]), _c('span', [_vm._v("字")])]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('span', {
    staticClass: "data-label"
  }, [_vm._v("预计时长")]), _vm._v(" "), _c('span', {
    staticClass: "data-value colored"
  }, [_vm._v(_vm._s(_vm.task.et))]), _c('span', [_vm._v("小时")])]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('span', {
    staticClass: "data-label"
  }, [_vm._v("任务酬劳")]), _vm._v(" "), _c('span', {
    staticClass: "data-value colored"
  }, [_vm._v(_vm._s(_vm.task.basePay))]), _c('span', [_vm._v("元/小时")])]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('span', {
    staticClass: "data-label"
  }, [_vm._v("预计总酬劳")]), _vm._v(" "), _c('span', {
    staticClass: "data-value colored"
  }, [_vm._v(_vm._s(_vm.task.basePay ? (_vm.task.basePay * _vm.task.et).toFixed(2) : 0))]), _c('span', [_vm._v("元")])])]), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('el-button', {
    staticClass: "submit-button",
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.nextTab('additionInfo')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('word.prevStep')))]), _vm._v(" "), _c('el-button', {
    staticClass: "submit-button",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.nextStep('task')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('comb.commitConfirm')))])], 1)])], 1)], 1)], 1), _vm._v(" "), _c('xi-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8f573d92!./~/vue-loader/lib/selector.js?type=template&index=0!./views/copyrighter/publishTask/BaseInfo.vue
// module id = 1052
// module chunks = 0